export default __webpack_public_path__ + "static/media/Tesla_logo.a7f4d496.png";